export default __webpack_public_path__ + "static/tkmaxx-a2e87b5000ffa16691773b2385e45f66.png";